import { SolType } from '@sol/components';
import { AutomationActionItem } from './automation-action';

export class AsmAutomationType {
  public static readonly automationActionItem = SolType.ofObject<AutomationActionItem>('asm.automationActionItem', {
    id: SolType.string,
    actionId: SolType.string,
    tags: SolType.string.array,
    subscopes: SolType.string.array,
    integrationIds: SolType.string.array,
    targetStatus: SolType.string,
    targetPlatformType: SolType.string,
    targetCookieType: SolType.string,
    targetRiskScore: SolType.string,
  });
}
